import React, { Component } from "react";
import classes from "./ARCCustomer.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import SellerCustomer from "../../../../asserts/templates/seller_customer.xlsx";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import CircularProgress from "@material-ui/core/CircularProgress";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import SelectField from "../../../../components/ui/select";
import { toast } from "react-toastify";
import CustomTable from "../../../../components/ui/Table/Table";
import { TablePagination } from "@material-ui/core";

import BoxWrapper from "../../../../components/ui/boxWrapper";
import RefreshIcon from "@mui/icons-material/Refresh";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import TuneIcon from "@mui/icons-material/Tune";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Chip from "@material-ui/core/Chip";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";

import BasicModal from "../../../../components/ui/basicModal";
import { flexbox } from "@mui/system";
import { canWrite } from "../../../../utils/privilegeUtils";

let flagForZoho = 1;
let variableForTimerInSalesCustomer = null;

// Set to true AFTER BoxWrapper has been given a `headerExtra` prop (render
// {props.headerExtra} right after its search input). The Filter button then
// appears next to the Customers Details search. While false, the button is
// rendered just above the table instead, so it never disappears.
const FILTER_BUTTON_IN_BOXWRAPPER = true;

const indianFormat = (date) => {
  let dateArr = date.split("-");
  return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
};

class BussinessCustomerMang extends Component {
  constructor(props) {
    super(props);

    this.state = {
      effitracCol: [
        {
          key: "customerCode",
          render: (index, row) => {
            return row["erp_cust_code"];
          },
        },
        {
          key: "legalName",
          render: (index, row) => {
            return row["cust_legal_name"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["cust_gstin"];
          },
        },
        {
          key: "pan",
          render: (index, row) => {
            return row["cust_pan"];
          },
        },

        {
          key: "tan",
          render: (index, row) => {
            return row["cust_tan"];
          },
        },
        {
          key: "tdsPercentage",
          render: (index, row) => {
            return row["tds_percentage"];
          },
        },
      ],
      effitracData: null,
      isCustVendorRequired: true,
      oldEffitracData: null,
      effitracHeader: [
        { label: "Customer Code" },
        { label: "Legal Name" },
        { label: "GSTIN" },
        { label: "PAN" },
        { label: "TAN" },
        { label: "TDS %" },
      ],
      actionHeaderForZoho: [
        { id: "cust_contact_name", name: "Contact Name" },
        { id: "cust_contact_email", name: "Contact Email" },
        { id: "cust_contact_no", name: "Contact No" },
        { id: "cust_address", name: "Address" },
        { id: "cust_state", name: "State" },
        { id: "cust_country", name: "Country" },
        { id: "cust_acctmgr_name", name: "Account Manager Name" },
        { id: "cust_acctmgr_email", name: "Account Manager Email" },
        { id: "cust_credit_limit", name: "Credit Limit" },
        { id: "cust_credit_days", name: "Credit Days" },
        { id: "cust_registration_type", name: "Registration Type" },
        { id: "TDS %", name: "tds_percentage" },
      ],
      read_only: "",
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      errorPage: 1,
      perErrorPages: 10,
      errortotal: 0,
      successful_records: 0,
      error_records: 0,
      loadingExport: false,
      error_rows: {},
      sellerCustomerCol: [
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["GSTIN"];
          },
        },
        {
          label: "Invoice Number",
          render: (name, all) => {
            return all["record"]["InvoiceNo"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
      ],
      sellerCustomerData: [],
      error: null,

      allArcCustomerData: [],
      OriginalDataAllArcCustomerData: [],
      showDrawer: false,
      showData: {},
      showUploadData: false,
      loading: true,

      add_DrawerOpen: false,
      addCustomerData: {},

      edit_DrawerOpen: false,
      editCustomerData: {},

      autoSync: false,

      openZohoDrawer: false,
      messageForConnection: "Establish Connection",
      buttonColor: "red",
      grantToken: "",
      url: "",
      zohoDate: {},

      openImportEffitracDrawer: false,
      importEffitracFetchData: {},
      effitracFetchedRecords: {},
      fetrac: "",
      actions: [
        {
          label: "Show",
          onclickEvent: (index, row) => this.openModal(index),
        },
      ],
      effitracInvShow: false,
      targetId: null,

      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      searchInput: "",

      uploadHistoryTableData: [],

      flagForZohoInSalesCustomer: false,
      timerForZohoInSalesCustomer: 60,

      isOpenUpdateTanModal: false,
      updateTanGetApiData: {},
      isLoaderforupdateTanButton: false,
      erpConnectorModelOpen: false,
      erpConnectorName: '',
      erpDataExportLoading: false,
      importToCwsLoading: false,
      isExporting: false,
      isExportingAll: false,

      // ---------------------------------------------------------------
      // COMMON FILTER (one "Filter" button for the whole table)
      // ---------------------------------------------------------------
      // Clicking "Filter" opens a compact side panel (attached to the table,
      // not a full-height drawer) that shows one labelled input for EVERY
      // filterable column. The user types values into any
      // number of them and presses "Apply Filter" — a single api call
      // commits everything. "Clear All" empties the inputs, removes all
      // filters and reloads the complete table.
      //
      // filterPanelOpen: whether the side panel next to the table is shown.
      filterPanelOpen: false,
      // advancedFiltersOpen: the "Advanced Filters" section is collapsed by default.
      advancedFiltersOpen: false,
      // draftValues: what is typed in the panel, keyed by column key,
      // e.g. { cust_pan: "ABCDE1234F", cust_state: "Tamil Nadu, Kerala" }.
      draftValues: {},
      // appliedFilters: the conditions actually in effect on the table.
      //   Each condition: { field, value } — value is the raw comma string.
      appliedFilters: [],
      // filterMatchType: "AND" (every condition must match) or "OR".
      filterMatchType: "AND",
      // Mirrors appliedFilters into the shape sent to the backend; kept in
      // state so pagination handlers can tell "filtered" from "unfiltered".
      activeFilters: null,
    };
  }

  // ---------------------------------------------------------------------
  // FILTERABLE / DISPLAY COLUMNS — grouped for the horizontal grouped
  // header. Add a field here (with its `group` and `width`) to make it
  // available in the table + filter panel — nothing else to wire.
  // `width` (px) gives every header/cell a fixed size so labels never
  // truncate; the table scrolls horizontally instead of squeezing columns.
  // ---------------------------------------------------------------------
  filterableColumns = [
    // Customer
    { key: "erp_cust_code", label: "ERP Code", group: "Customer", width: 130 },
    { key: "cust_legal_name", label: "Legal Name", group: "Customer", width: 200 },
    { key: "cust_registration_type", label: "Reg. Type", group: "Customer", width: 120 },

    // Tax Details
    { key: "cust_gstin", label: "GSTIN", group: "Tax Details", width: 150 },
    { key: "cust_pan", label: "PAN", group: "Tax Details", width: 110 },
    { key: "cust_tan", label: "TAN", group: "Tax Details", width: 110 },
    { key: "tds_percentage", label: "TDS %", group: "Tax Details", width: 90 },
    { key: "entity_gstin", label: "Entity GSTIN", group: "Tax Details", width: 150 },

    // Location
    { key: "cust_address", label: "Address", group: "Location", width: 240 },
    { key: "cust_state", label: "State", group: "Location", width: 120 },
    { key: "cust_country", label: "Country", group: "Location", width: 110 },
    { key: "branch_name", label: "Branch", group: "Location", width: 130 },

    // Contact
    { key: "cust_contact_name", label: "Contact Name", group: "Contact", width: 160 },
    { key: "cust_contact_no", label: "Contact No", group: "Contact", width: 130 },
    { key: "cust_contact_email", label: "Contact Email", group: "Contact", width: 200 },

    // Account Manager
    { key: "cust_acctmgr_name", label: "Manager Name", group: "Account Manager", width: 160 },
    { key: "cust_acctmgr_no", label: "Manager No", group: "Account Manager", width: 130 },
    { key: "cust_acctmgr_email", label: "Manager Email", group: "Account Manager", width: 200 },

    // Credit
    { key: "cust_credit_days", label: "Credit Days", group: "Credit", width: 120 },
    { key: "cust_credit_limit", label: "Credit Limit", group: "Credit", width: 140 },

    // Other
    { key: "status", label: "Status", group: "Other", width: 100 },
    { key: "msme", label: "MSME", group: "Other", width: 100 },
    { key: "cin", label: "CIN", group: "Other", width: 150 },
  ];

  // Fixed width (px) for the trailing sticky "SHOW" column.
  SHOW_COL_WIDTH = 70;

  // Filter panel sections. Basic filters are open by default; every other
  // column in `filterableColumns` goes into the collapsed Advanced section.
  BASIC_FILTER_KEYS = [
    "erp_cust_code",
    "cust_legal_name",
    "cust_gstin",
    "cust_pan",
    "cust_tan",
    "cust_registration_type",
    "cust_state",
    "cust_country",
  ];

  // Registration Type is a dropdown (values as used by the Add/Edit forms).
  REGISTRATION_TYPE_OPTIONS = [
    "Regular",
    "Unregistered",
    "Consumer",
    "Composition",
    "B2C",
    "SEZ",
    "Unknown",
  ];

  getBasicFilterColumns = () =>
    this.BASIC_FILTER_KEYS.map((k) =>
      this.filterableColumns.find((c) => c.key === k)
    ).filter(Boolean);

  // Same value for every row of an entity, so filtering on them is useless.
  // They stay in the table, but are left out of the filter panel.
  FILTER_EXCLUDED_KEYS = ["entity_gstin", "branch_name"];

  // Available in the API response but not shown as a table column.
  FILTER_EXTRA_COLUMNS = [{ key: "cust_code", label: "Customer Code" }];

  getAdvancedFilterColumns = () =>
    this.filterableColumns
      .filter(
        (c) =>
          !this.BASIC_FILTER_KEYS.includes(c.key) &&
          !this.FILTER_EXCLUDED_KEYS.includes(c.key)
      )
      .concat(this.FILTER_EXTRA_COLUMNS);

  // Header colours — subtle tints of the app's navy (#03406f) on neutral greys.
  HEADER_GROUP_BG = "#e6ecf2";
  HEADER_LABEL_BG = "#f5f7f9";
  HEADER_TEXT = "#03406f";
  HEADER_BORDER = "#d3dce5";

  // Distinct groups, in first-seen order, with how many columns each spans
  // — drives the top header row's colSpan per group band.
  getColumnGroups = () => {
    const groups = [];
    this.filterableColumns.forEach((col) => {
      const existing = groups.find((g) => g.name === col.group);
      if (existing) {
        existing.span += 1;
      } else {
        groups.push({ name: col.group, span: 1 });
      }
    });
    return groups;
  };

  // Total pixel width of every column belonging to a given group — used to
  // size the group-band <th> so it lines up exactly with the columns below it.
  getGroupWidth = (groupName) =>
    this.filterableColumns
      .filter((c) => c.group === groupName)
      .reduce((sum, c) => sum + c.width, 0);

  // Sum of every column's width plus the sticky SHOW column — used as the
  // table's min-width so the horizontal scrollbar kicks in instead of the
  // browser squeezing columns to fit.
  getTableMinWidth = () =>
    this.filterableColumns.reduce((sum, c) => sum + c.width, this.SHOW_COL_WIDTH);

  getFieldMeta = (fieldKey) =>
    this.filterableColumns.find((c) => c.key === fieldKey) ||
    this.FILTER_EXTRA_COLUMNS.find((c) => c.key === fieldKey) ||
    this.filterableColumns[0];

  // Splits a raw string on commas into trimmed, non-empty, de-duplicated
  // values. Used for every filter value so a person can paste
  // "mr.gg, amazon, tax, cts" into a value box and match any of them.
  parseBulkFilterValues = (raw) => {
    return Array.from(
      new Set(
        (raw || "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
      )
    );
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          newPage,
          this.state.rowsPerPage
        );
      } else {
        this.getSellercustomerDataApi(this.state.searchInput);
      }
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          0,
          newRowsPerPage
        );
      } else {
        this.getSellercustomerDataApi(this.state.searchInput);
      }
    });
  };

  // Search respects any applied filters (the filter API already receives
  // `searchInput`), so typing in the search box never silently drops them.
  handleSearchInputChange = (event) => {
    this.setState(
      { searchInput: event.target.value, page: 0, rowsPerPage: 25 },
      () => {
        if (this.state.appliedFilters.length > 0) {
          this.applyDynamicFilters(
            this.state.appliedFilters,
            this.state.filterMatchType,
            0,
            this.state.rowsPerPage
          );
        } else {
          this.getSellercustomerDataApi(this.state.searchInput);
        }
      }
    );
  };

  openModal = (index) => {
    this.setState(
      {
        targetId: index,
      },
      () => {
        this.setState({
          effitracInvShow: true,
        });
      }
    );
  };

  getIsCustVendorRequired = () => {
    axios
      .get(`/get_complete_entity_data/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        this.setState({
          isCustVendorRequired: res.data.Entity.is_cust_vendor_required,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  closeEffitracInvShowHandler = () => {
    this.setState({
      effitracInvShow: false,
      targetId: null,
    });
  };

  getSellercustomerDataApi = (serachIn) => {
    axios
      .post(`/arc/sellerCustomer`, {
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
        search_txt: serachIn,
        seller_code: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcCustomerData: res.data.records,
          OriginalDataAllArcCustomerData: res.data.records,
          rowCount: res.data.row_count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Generic filter API call — takes the { match_type, conditions } payload
  // built by applyDynamicFilters and posts it once for ALL active conditions.
  getSellercustomerFilterApi = (filters = {}, page = 0, rowsPerPage = this.state.rowsPerPage) => {
    this.setState({ loading: true });

    axios
      .post(`/arc/sellerCustomerFilter`, {   // ← change URL if your route is different
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: this.state.searchInput || "",
        filters: filters,
        number_of_rows_per_page: rowsPerPage,
        page_number: page,
      })
      .then((res) => {
        this.setState({
          allArcCustomerData: res.data.records || [],
          OriginalDataAllArcCustomerData: res.data.records || [],
          rowCount: res.data.row_count || 0,
          loading: false,
          page: page,
          rowsPerPage: rowsPerPage,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  getSellercustomerLastUploadDate = () => {
    const customer = "Seller Customer";
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id"
        )}/${customer}`
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = indianFormat(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDate: Date,
          lastUploadTime: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        res?.data?.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id)
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getHistoryTableUploadData = () => {
    axios
      .get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          "business_entity_id"
        )}/${1}`
      )
      .then((res) => {
        this.setState({ uploadHistoryTableData: res.data.record });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    console.log("INSIDE componentDidMount of BUSINESS CUSTOMER MANAGEMENT")
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });

    let drawer = domain.get("drawer");
    drawer &&
      this.setState({
        openZohoDrawer: true,
        messageForConnection: "Connection Established",
        buttonColor: "green",
      });

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);
    this.getApiForClientID();
    this.getSellercustomerDataApi();
    this.getSellercustomerLastUploadDate();
    this.getHistoryTableUploadData();
    this.getErpConnectorName();
    this.getIsCustVendorRequired();
  }

  componentWillUnmount() {
    if (variableForTimerInSalesCustomer) {
      clearInterval(variableForTimerInSalesCustomer);
    }
  }

  getErpConnectorName = () => {
    axios.get(`/arc/verify_erp_data_pull_eligibility/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        if (res?.data?.status) {
          this.setState({ erpConnectorName: res?.data?.data })
        }
      }).catch((err) => {

      })
  }

  componentDidUpdate() {
    if (
      this.state.buttonColor === "green" &&
      !this.state.flagForZohoInSalesCustomer
    ) {
      this.setState({ flagForZohoInSalesCustomer: true });
      variableForTimerInSalesCustomer = setInterval(() => {
        this.setState((prevstate) => ({
          timerForZohoInSalesCustomer:
            prevstate.timerForZohoInSalesCustomer - 1,
        }));
      }, 1000);
    }

    if (this.state.timerForZohoInSalesCustomer === 0) {
      clearInterval(variableForTimerInSalesCustomer);
      this.setState({
        flagForZohoInSalesCustomer: false,
        timerForZohoInSalesCustomer: 60,
        buttonColor: "red",
      });
    }
  }

  handleSearchChangeForZohoEffitrack = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    let { searchInput } = this.state;
    let searchAdminData = this.state.oldEffitracData.filter((value) => {
      const query = searchInput.trim().toLowerCase();
      return (
        String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_legal_name).toLowerCase().indexOf(query) >= 0 ||
        String(value.erp_cust_code).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_pan).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_tan).toLowerCase().indexOf(query) >= 0 ||
        String(value.tds_percentage).toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ effitracData: searchAdminData });
  };

  handleBackNavigation = () => {
    this.props.history.push('/Data-Upload');
  };

  fileUploader = (event) => {
    this.setState({ loading: true });

    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);

    let dis = this;

    reader.onload = function () {
      let file_value = reader.result;

      axios
        .post(`arc/excelupload/sellercustomer`, {
          file: file_value,
          business_entity_id: parseInt(
            localStorage.getItem("business_entity_id")
          ),
        })
        .then((data) => {
          const message = data?.data?.message;

          if (message) {
            toast.error(message);
            dis.setState({ loading: false });
            return;
          }

          dis.getHistoryTableUploadData();
          dis.setState({ loading: false });

          axios
            .post(`/arc/sellerCustomer`, {
              number_of_rows_per_page: dis.state.rowsPerPage,
              page_number: dis.state.page,
              search_txt: "",
              seller_code: localStorage.getItem("business_entity_id"),
            })
            .then((res) => {
              dis.setState(
                {
                  allArcCustomerData: res.data.records,
                  OriginalDataAllArcCustomerData: res.data.records,
                },
                () => {
                  // Re-apply whatever filters were active before the upload.
                  dis.applyDynamicFilters(
                    dis.state.appliedFilters,
                    dis.state.filterMatchType,
                    dis.state.page,
                    dis.state.rowsPerPage
                  );
                }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          dis.setState({
            error: error?.response?.data?.message,
            total_records: 0,
          });
        });
    };
  };

  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData();
    this.getSellercustomerDataApi();
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER — state handlers
  // -----------------------------------------------------------------------

  // Opens the panel, pre-filled with whatever is currently applied so the
  // person always sees what is live.
  // The Filter button toggles the panel.
  openFilterPanel = () => {
    if (this.state.filterPanelOpen) {
      this.setState({ filterPanelOpen: false });
      return;
    }
    const draftValues = {};
    this.state.appliedFilters.forEach((c) => {
      draftValues[c.field] = c.value;
    });
    this.setState({ filterPanelOpen: true, draftValues });
  };

  // Closing without pressing "Apply Filter" discards unapplied edits.
  closeFilterPanel = () => {
    this.setState({ filterPanelOpen: false });
  };

  toggleAdvancedFilters = () => {
    this.setState((prev) => ({ advancedFiltersOpen: !prev.advancedFiltersOpen }));
  };

  // Chip cross: removes ONE applied filter and reloads the table.
  removeAppliedFilter = (field) => {
    const conditions = this.state.appliedFilters.filter((c) => c.field !== field);
    this.setState(
      (prev) => {
        const draftValues = { ...prev.draftValues };
        delete draftValues[field];
        return { appliedFilters: conditions, draftValues, page: 0 };
      },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  handleDraftValueChange = (key) => (event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      draftValues: { ...prev.draftValues, [key]: value },
    }));
  };

  // Excel copy-paste brings multiple values separated by newlines (rows) or
  // tabs (columns), with no commas. Convert that shape into the same
  // comma-separated "is any of" format, appending to whatever is typed.
  handleFilterValuePaste = (key) => (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // single value — default paste

    e.preventDefault();
    const joined = pasted
      .split(/[\r\n\t]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .join(", ");
    if (!joined) return;

    this.setState((prev) => {
      const current = (prev.draftValues[key] || "").replace(/\s+$/, "");
      const next = !current
        ? joined
        : current.endsWith(",")
        ? `${current} ${joined}`
        : `${current}, ${joined}`;
      return { draftValues: { ...prev.draftValues, [key]: next } };
    });
  };

  // Enter inside any input applies the filter.
  handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.applyFilterFromPanel();
    }
  };

  // "Apply Filter" — every non-empty input becomes a condition, and the
  // whole set is sent in ONE api call.
  applyFilterFromPanel = () => {
    const conditions = [
      ...this.getBasicFilterColumns(),
      ...this.getAdvancedFilterColumns(),
    ]
      .map((c) => ({
        field: c.key,
        value: (this.state.draftValues[c.key] || "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState(
      { appliedFilters: conditions, filterPanelOpen: false, page: 0 },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  // "Clear All" — empties the inputs, removes every filter, and reloads the
  // complete table.
  handleClearAllFilters = () => {
    this.setState(
      { draftValues: {}, appliedFilters: [], page: 0 },
      () =>
        this.applyDynamicFilters(
          [],
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  // Builds the backend payload from the current conditions and either calls
  // the filter API (when conditions exist) or falls back to the normal
  // paginated listing (when the filter set is empty). Every condition is
  // sent as operator "in" — "field value is any of these".
  applyDynamicFilters = (
    conditions = this.state.appliedFilters,
    matchType = this.state.filterMatchType,
    page = 0,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ activeFilters: null });
      this.getSellercustomerDataApi(this.state.searchInput);
      return;
    }

    const payload = conditions.map((c) => ({
      field: c.field,
      operator: "in",
      value: this.parseBulkFilterValues(c.value),
    }));

    const filters = { match_type: matchType, conditions: payload };
    this.setState({ activeFilters: filters });
    this.getSellercustomerFilterApi(filters, page, rowsPerPage);
  };

  CollectionListActions = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        {(localStorage.getItem('is_uploads') !== "N") && (
          <>
            <a
              href={SellerCustomer}
              download={"seller_customer.xlsx"}
              style={{ textDecoration: "none" }}
            >
              <Button component="label" size="small" color="primary">
                <GetAppIcon style={{ fontSize: "20px" }} />
                DOWNLOAD TEMPLATE
              </Button>
            </a>

           {this.state.isCustVendorRequired && canWrite("UPLOADING SALES") && (
            <Button component="label" size="small" color="primary">
              <PublishIcon style={{ fontSize: "20px" }} />
              UPLOAD TEMPLATE
              <input
                accept=".xlsx"
                name="file"
                type="file"
                value=""
                hidden
                onChange={this.fileUploader}
              />
            </Button>
            )}
          </>
        )}
      </div>
      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
    </div>
  );

  // -----------------------------------------------------------------------
  // COMMON FILTER — rendering
  // -----------------------------------------------------------------------
  // 1) renderFilterButton: one plain "Filter" button (shows "Filter (n)"
  //    when filters are active). It toggles the panel.
  // 2) renderFilterPanel: a compact side panel that sits NEXT TO the table
  //    inside the same flex row (not position: fixed), so it never covers
  //    the app header/sidebar. It has a subtle border, a "Filters" header
  //    with a close icon and divider, a scrollable list of labelled inputs
  //    (one per column), and a footer with Apply Filter / Clear All.

  renderFilterButton = () => {
    const appliedCount = this.state.appliedFilters.length;
    return (
      <button
        type="button"
        className="button-outlined-primary"
        onClick={this.openFilterPanel}
        style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <FilterAltOutlinedIcon style={{ fontSize: "18px" }} />
        {appliedCount > 0 ? `Filter (${appliedCount})` : "Filter"}
      </button>
    );
  };

  // One label + white input (or dropdown for Registration Type).
  renderFilterField = (col) => {
    const { draftValues } = this.state;
    const common = {
      fullWidth: true,
      size: "small",
      variant: "outlined",
      value: draftValues[col.key] ?? "",
      onChange: this.handleDraftValueChange(col.key),
      InputProps: { style: { background: "#fff" } },
    };

    return (
      <div key={col.key} style={{ minWidth: 0 }}>
        <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
          {col.label}
        </label>
        {col.key === "cust_registration_type" ? (
          <TextField {...common} select SelectProps={{ native: true }}>
            <option value="">Select</option>
            {this.REGISTRATION_TYPE_OPTIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </TextField>
        ) : (
          <TextField
            {...common}
            placeholder={`Enter ${col.label.toLowerCase()}`}
            onPaste={this.handleFilterValuePaste(col.key)}
            onKeyDown={this.handleFilterKeyDown}
          />
        )}
      </div>
    );
  };

  renderFilterPanel = () => {
    const { filterPanelOpen, draftValues, advancedFiltersOpen } = this.state;
    if (!filterPanelOpen) return null;

    const advancedColumns = this.getAdvancedFilterColumns();
    const advancedCount = advancedColumns.filter(
      (c) => (draftValues[c.key] || "").trim() !== ""
    ).length;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    };

    return (
      <div
        style={{
          width: 440,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          minHeight: 360,
          // Keeps the panel table-sized; the body scrolls inside.
          maxHeight: "calc(100vh - 260px)",
          border: `1px solid ${this.HEADER_TEXT}`,
          borderRadius: 4,
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(3,64,111,0.12)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 6px 6px 14px",
            background: this.HEADER_TEXT,
            color: "#ffffff",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Filters</span>
          <Tooltip title="Close" arrow>
            <IconButton size="small" onClick={this.closeFilterPanel}>
              <ClearIcon style={{ fontSize: "16px", color: "#ffffff" }} />
            </IconButton>
          </Tooltip>
        </div>

        {/* Body: Basic (open) + Advanced (collapsed) */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "12px 14px",
            background: "#eef3f8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              marginBottom: "10px",
            }}
          >
            Basic Filters
          </div>
          <div style={gridStyle}>
            {this.getBasicFilterColumns().map((col) => this.renderFilterField(col))}
          </div>

          <div
            role="button"
            onClick={this.toggleAdvancedFilters}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              marginTop: "14px",
              padding: "10px 0",
              borderTop: `1px solid ${this.HEADER_BORDER}`,
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              userSelect: "none",
            }}
          >
            <span>
              {advancedCount > 0
                ? `Advanced Filters (${advancedCount})`
                : "Advanced Filters"}
            </span>
            {advancedFiltersOpen ? (
              <ExpandLessIcon style={{ fontSize: "20px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "20px" }} />
            )}
          </div>
          {advancedFiltersOpen && (
            <div style={gridStyle}>
              {advancedColumns.map((col) => this.renderFilterField(col))}
            </div>
          )}
        </div>

        {/* Footer — bottom right */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 14px",
            background: this.HEADER_GROUP_BG,
            borderTop: `1px solid ${this.HEADER_BORDER}`,
          }}
        >
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={this.handleClearAllFilters}
          >
            Clear All
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={this.applyFilterFromPanel}
          >
            Apply Filters
          </button>
        </div>
      </div>
    );
  };

  // Applied filters as small chips, each with its own cross.
  renderAppliedFilterChips = () => {
    const { appliedFilters } = this.state;
    if (appliedFilters.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "8px",
        }}
      >
        {appliedFilters.map((c) => (
          <Chip
            key={c.field}
            size="small"
            variant="outlined"
            label={`${this.getFieldMeta(c.field).label}: ${c.value}`}
            onDelete={() => this.removeAppliedFilter(c.field)}
            style={{
              maxWidth: 280,
              backgroundColor: this.HEADER_GROUP_BG,
              color: this.HEADER_TEXT,
              borderColor: this.HEADER_BORDER,
            }}
          />
        ))}
      </div>
    );
  };

  // -----------------------------------------------------------------------
  // GROUPED HEADER — two sticky rows:
  //   1) a colored "group band" row (Customer / Tax Details / Location /
  //      Contact / Account Manager / Credit / Other), each spanning all of
  //      its columns via colSpan, sized to match the total width of its
  //      columns so the band lines up exactly with the labels below it
  //   2) the individual column-label row underneath it, each cell with a
  //      fixed width so labels stop truncating
  // The trailing SHOW header cell is `position: sticky; right: 0` so it
  // stays pinned to the right edge while the table scrolls horizontally.
  // Returns an array of two <tr> elements so the caller can drop both
  // straight into <tbody>.
  // -----------------------------------------------------------------------
  arc_Customer_TableHeader() {
    const groups = this.getColumnGroups();

    const groupRow = (
      <tr key="group-row">
        {groups.map((g) => {
          const width = this.getGroupWidth(g.name);
          return (
            <th
              key={g.name}
              colSpan={g.span}
              style={{
                position: "sticky",
                top: 0,
                zIndex: 510,
                width: width,
                minWidth: width,
                maxWidth: width,
                padding: "6px 8px",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                color: this.HEADER_TEXT,
                background: this.HEADER_GROUP_BG,
                textAlign: "center",
                borderRight: `1px solid ${this.HEADER_BORDER}`,
                borderBottom: `1px solid ${this.HEADER_BORDER}`,
                whiteSpace: "nowrap",
                boxSizing: "border-box",
              }}
            >
              {g.name}
            </th>
          );
        })}
        <th
          rowSpan={2}
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            zIndex: 520,
            width: this.SHOW_COL_WIDTH,
            minWidth: this.SHOW_COL_WIDTH,
            maxWidth: this.SHOW_COL_WIDTH,
            backgroundColor: this.HEADER_GROUP_BG,
            color: this.HEADER_TEXT,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            textAlign: "center",
            borderLeft: `1px solid ${this.HEADER_BORDER}`,
            borderBottom: `1px solid ${this.HEADER_BORDER}`,
            boxShadow: "-2px 0 4px rgba(0,0,0,0.06)",
            boxSizing: "border-box",
          }}
        >
          SHOW
        </th>
      </tr>
    );

    const labelRow = (
      <tr key="label-row">
        {this.filterableColumns.map((col, index) => (
          <th
            key={index}
            style={{
              position: "sticky",
              top: "29px",
              zIndex: 500,
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              backgroundColor: this.HEADER_LABEL_BG,
              padding: "6px 8px",
              fontSize: "11.5px",
              fontWeight: 600,
              color: "#334155",
              textAlign: "center",
              borderRight: `1px solid ${this.HEADER_BORDER}`,
              borderBottom: `1px solid ${this.HEADER_BORDER}`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
            }}
          >
            {col.label.toUpperCase()}
          </th>
        ))}
      </tr>
    );

    return [groupRow, labelRow];
  }

  showToggleDrawer = (
    CustRegistrationType,
    CustAcctmgrName,
    CustAcctmgrNo,
    CustAcctmgrEmail,
    CustCreditLimit,
    Status,
    CustAddress,
    CustContactName,
    CustContactEmail,
    CustContactNo,
    CustState,
    seller_code,
    CustCreditDays,
    CustCountry,
    created_date,
    modified_date,
    tds_percentage
  ) => {
    this.setState({
      showData: {
        CustRegistrationType: CustRegistrationType,
        CustAcctmgrName: CustAcctmgrName,
        CustAcctmgrNo: CustAcctmgrNo,
        CustAcctmgrEmail: CustAcctmgrEmail,
        CustCreditLimit: CustCreditLimit,
        Status: Status,
        CustAddress: CustAddress,
        CustContactName: CustContactName,
        CustContactEmail: CustContactEmail,
        CustContactNo: CustContactNo,
        CustState: CustState,
        seller_code: seller_code,
        CustCreditDays: CustCreditDays,
        CustCountry: CustCountry,
        created_date: created_date,
        modified_date: modified_date,
        tds_percentage: tds_percentage,
      },
      showDrawer: true,
    });
  };

  // -----------------------------------------------------------------------
  // DATA ROWS — one <td> per entry in `filterableColumns`, generic, kept in
  // sync with the header automatically. Each cell is sized to match its
  // column's fixed width. The trailing SHOW icon cell still opens the same
  // drawer with the same fields as before, and is pinned to the right edge
  // with `position: sticky` so it stays visible while scrolling horizontally.
  // -----------------------------------------------------------------------
  arc_Customer__data() {
    if (this.state.allArcCustomerData.length >= 1) {
      return this.state.allArcCustomerData.map((tableData, index) => {
        const {
          created_date,
          cust_acctmgr_email,
          cust_acctmgr_name,
          cust_acctmgr_no,
          cust_address,
          cust_code,
          erp_cust_code,
          cust_contact_email,
          cust_contact_name,
          cust_contact_no,
          cust_country,
          cust_credit_days,
          cust_credit_limit,
          cust_gstin,
          cust_legal_name,
          cust_pan,
          cust_registration_type,
          cust_state,
          cust_tan,
          modified_date,
          seller_code,
          status,
          tds_percentage,
        } = tableData;

        return (
          <tr key={index}>
            {this.filterableColumns.map((col) => (
              <td
                key={col.key}
                style={{
                  width: col.width,
                  minWidth: col.width,
                  maxWidth: col.width,
                  borderRight: "1px solid #f1f5f9",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "6px 8px",
                  boxSizing: "border-box",
                }}
              >
                {tableData[col.key] !== null && tableData[col.key] !== undefined
                  ? tableData[col.key]
                  : "-"}
              </td>
            ))}
            <td
              style={{
                position: "sticky",
                right: 0,
                width: this.SHOW_COL_WIDTH,
                minWidth: this.SHOW_COL_WIDTH,
                maxWidth: this.SHOW_COL_WIDTH,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  this.showToggleDrawer(
                    cust_registration_type,
                    cust_acctmgr_name,
                    cust_acctmgr_no,
                    cust_acctmgr_email,
                    cust_credit_limit,
                    status,
                    cust_address,
                    cust_contact_name,
                    cust_contact_email,
                    cust_contact_no,
                    cust_state,
                    seller_code,
                    cust_credit_days,
                    cust_country,
                    created_date,
                    modified_date,
                    tds_percentage
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loading) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.filterableColumns.length + 1}
          >
            Loading...Please Wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.filterableColumns.length + 1}>
            {this.state.appliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={this.handleClearAllFilters}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }

  showToggleDrawerClose = (event) => {
    this.setState({ showDrawer: false });
  };

  closeUploadData = () => {
    this.setState({ showUploadData: false });
    this.getSellercustomerDataApi();
  };

  addCustomer_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      addCustomerData: {
        ...prevState.addCustomerData,
        [name]: String(value),
      },
    }));
  };

  addCustomer_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addCustomerData: {
        ...prevState.addCustomerData,
        [name]: parseFloat(numb),
      },
    }));
  };

  addCustomer_submitHamdler = () => {
    this.setState({ buttonDisabled: true });
    axios
      .post(`/arc/ui/sellercustomer`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.addCustomerData],
      })
      .then((res) => {
        if (res.data.status === false) {
          this.setState({ buttonDisabled: false });
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.getSellercustomerDataApi();
          this.setState({
            add_DrawerOpen: false,
            addCustomerData: {},
            buttonDisabled: false,
          });
          toast.success("Customer added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        this.setState({ buttonDisabled: false });
        toast.error("Server Error, Unable to add Customer", {
          autoClose: 2000,
        });
      });
  };

  add_DrawerClose = () => {
    this.setState({
      add_DrawerOpen: false,
      addCustomerData: {},
      buttonDisabled: false,
    });
  };

  editCustomer_drawerOpen = () => {
    this.setState({ edit_DrawerOpen: true });
  };

  editCustomer_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      editCustomerData: {
        ...prevState.editCustomerData,
        [name]: String(value),
      },
    }));
  };

  editCustomer_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editCustomerData: {
        ...prevState.editCustomerData,
        [name]: parseFloat(numb),
      },
    }));
  };

  editCustomer_submitHamdler = () => {
    this.setState({ buttonDisabled: true });
    axios
      .post(`/arc/ui/sellercustomer`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.editCustomerData],
      })
      .then((res) => {
        if (res.data.status === false) {
          this.setState({ buttonDisabled: false });
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.getSellercustomerDataApi();
          this.setState({ edit_DrawerOpen: false, buttonDisabled: false });
          toast.success("Customer updated successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        toast.error("Server Error, Unable to edit Customer", {
          autoClose: 2000,
        });
        this.setState({ buttonDisabled: false });
        this.setState({ edit_DrawerOpen: false });
      });
  };

  edit_DrawerClose = () => {
    this.setState({ edit_DrawerOpen: false, buttonDisabled: false });
  };

  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };


  export_erp_data_to_excel = (apPointName, transId) => {
    this.setState({ erpDataExportLoading: true })
    let data = [];
      const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `Customers.xlsx`;
    this.setState({ isExporting: true });
    const payLoadData = {
      'business_entity_id': localStorage.getItem('business_entity_id'),
      'record_type': apPointName,
      'record_id': transId
    }
    axios.post('/export_erp_connector_data', payLoadData)
      .then((res) => {
        if (res) {
         this.downloadBase64File(contentType, res.data.data, filename);
        } else {
          toast.error("Data not found. Please try again later.", {
            autoClose: 2000,
          });

        }
      })
      .catch((error) => { console.log(error); })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, isExporting: false });
      })
  };

  export_to_excel = (dataFromFunction, loadingKey = "isExporting") => {
    let data = dataFromFunction;
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `Customers.xlsx`;
    // loadingKey says which button shows the spinner (default: Export).
    this.setState({ [loadingKey]: true });
    axios
      .post(`/seller_customer_extract/download`, { data: data })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => { console.log(error); })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, [loadingKey]: false });
      });
  };

  // Export button: when filters are applied, export EVERY record that matches
  // them (not just the page on screen) by calling the existing filter api
  // without pagination, then hand the records to the existing export_to_excel.
  // With no filters applied it behaves exactly as before.
  export_filtered_or_current = (loadingArg) => {
    // Called from a button click, loadingArg may be the click event; only the
    // Export All / Export Filtered button passes "isExportingAll".
    const loadingKey = loadingArg === "isExportingAll" ? "isExportingAll" : "isExporting";
    const { appliedFilters, activeFilters } = this.state;
    if (!appliedFilters || appliedFilters.length === 0 || !activeFilters) {
      this.export_to_excel(this.state.allArcCustomerData);
      return;
    }

    this.setState({ [loadingKey]: true });
    axios
      .post(`/arc/sellerCustomerFilter`, {
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: this.state.searchInput || "",
        filters: activeFilters,
        // one page as big as the whole filtered result => all matching records
        number_of_rows_per_page: Math.max(this.state.rowCount || 0, 1),
        page_number: 0,
      })
      .then((res) => {
        const records = res?.data?.records || [];
        if (records.length === 0) {
          this.setState({ [loadingKey]: false });
          toast.error("No records found for the selected filters");
          return;
        }
        this.export_to_excel(records, loadingKey);
      })
      .catch((error) => {
        console.log(error);
        this.setState({ [loadingKey]: false });
        toast.error("Failed to export filtered data");
      });
  };

   exportall_to_excel = (dataFromFunction) => {
    let data = dataFromFunction;

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `Customers.xlsx`;
    this.setState({ isExportingAll: true });
    axios
      .post(`/seller_customer_extract/download`, {
        allData: true,
        business_entity_id: localStorage.getItem("business_entity_id")
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => { console.log(error); })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, isExportingAll: false });
      });
  };

  handleZohoDrawer = () => {
    flagForZoho = 1;
    this.setState({ openZohoDrawer: true });
  };

  closeZohoDrawer = () => {
    clearInterval(variableForTimerInSalesCustomer);
    this.setState({
      zohoDate: {},
      openZohoDrawer: false,
      effitracImportFormloader: false,
      buttonColor: "red",
      messageForConnection: "Establish Connection",
      grantToken: "",
    });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };

  import_Effitrac_tally = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importEffitracCreatedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        createdFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importEffitracCreatedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        createdToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importEffitracFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importEffitracModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  fetchEffitacFormSubmitHandler = () => {
    this.setState({ effitracImportFormloader: true });
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        business_entity_id: localStorage.getItem("business_entity_id"),
      },
    }));
    const data = this.state.importEffitracFetchData;
    axios
      .post("/arc/effitrac/customerdataexport", data)
      .then((res) => {
        this.setState({
          isEffitrac: true,
          effitracData: res.data.records.records,
          oldEffitracData: res.data.records.records,
          importEffitracFetchData: {},
          openImportEffitracDrawer: false,
          effitracImportFormloader: false,
        });
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message, {
          autoClose: 2000,
        });
        this.setState({ effitracImportFormloader: false });
      });
  };

  closeEffitracDrawer = () => {
    this.setState({
      openImportEffitracDrawer: false,
      importEffitracFetchData: {},
      effitracImportFormloader: false,
    });
  };

  closeEffitracInvShowHandler = () => {
    this.setState({
      effitracInvShow: false,
      targetId: null,
    });
  };

  importToCWS = (dataForFun, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true })
    let payLoadData = {}
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForFun,
        upload_type: uploadType,
        api_point_name: "customer",
        is_import: true,
        record_id: transId
      }
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForFun,
        upload_type: uploadType
      }
    }
    axios
      .post("/arc/effitrac/sellercustomer", payLoadData)
      .then((res) => {
        this.refreshUploadHistoryTable();
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });
      })
      .catch((error) => {
        toast.error(error?.response?.data?.messge, {
          autoClose: 5000,
          progress: 0,
        });
      }).finally(() => {
        this.setState({ importToCwsLoading: false })
        this.closeErpDrawer()
      });
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };

  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      this.setState({ errorPage: newPage }, () => {
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      this.setState({ errorPage: newPage }, () => {
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        this.uploadReport(null, 1);
      }
    );
  };

  backHandler = () => {
    this.setState({ isEffitrac: false });
  };

  establishConnection = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID"
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

zohoDateChangeHandler = (item) => {
  const { name, value } = item;
  if (value != "Invalid Date" && value != null) {
    var d = new Date(value);
    var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    let dateValue = newd.toISOString().replace("Z", "");

    this.setState((prevState) => ({   
      zohoDate: {
        ...prevState.zohoDate,
        [name]: dateValue,
      },
    }));
  }
};

  fetchingdataForZoho = () => {
    clearInterval(variableForTimerInSalesCustomer);
    flagForZoho += 1;

    this.setState({ effitracImportFormloader: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        type_of_data: "seller_customer",
        code: this.state.grantToken,
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            effitracImportFormloader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            zohoDate: {},
            autoSync: false,
          });
        } else {
          this.setState({
            effitracImportFormloader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            zohoDate: {},
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          buttonColor: "red",
          messageForConnection: "Establish Connection",
          grantToken: "",
          zohoDate: {},
          effitracImportFormloader: false,
          autoSync: false,
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });

  };

  uploadReport = (id, pageParam = null) => {
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem('uploadReportId');
    }

    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    localStorage.setItem('uploadReportId', currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        const res = response.data.records;

        if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
          const error_records = res.records.details.filter((v) => v.status === "Fail");
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records: parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false,
          });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  uploadTanGetApiHandler = () => {
    this.setState({ isLoaderforupdateTanButton: true });
    axios
      .get(`/karza_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data) {
          this.setState({
            updateTanGetApiData: res.data,
            isLoaderforupdateTanButton: false,
          });

          this.setState({ isOpenUpdateTanModal: true });
        }
      });
  };

  uploadTanPostApiHandler = () => {
    axios
      .get(`/karza_tan/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data && res.data.status === true) {
          toast.success(res.data.Message, {
            autoClose: 3000,
          });
          this.setState({ isOpenUpdateTanModal: false });
        } else {
          toast.error(res.data.Message, {
            autoClose: 3000,
          });
        }
      });
  };

  uploadTanCancelHandler = () => {
    this.setState({ isOpenUpdateTanModal: false });
  };

  errorLogExportHandlerForUpload = () => {
    this.setState({ loadingExport: true });
    let uploadId = localStorage.getItem('uploadReportId');

    let data = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      upload_id: uploadId,
    };

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `CustomersUploadErrorLog.xlsx`;

    axios
      .post(`/uploads_errors_extract/download`, data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
        this.setState({ loadingExport: false });
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        this.setState({ loadingExport: false });
      });
  };

  handleErpConnectorButton = () => {
    this.setState({ erpConnectorModelOpen: true })
  }

  render() {
    return (
      <React.Fragment>
        {(localStorage.getItem('is_uploads') !== "N") && <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 20px',
              marginBottom: '10px',
            }}
          >
            <Tooltip title="Back" arrow>
              <IconButton
                onClick={this.handleBackNavigation}
                sx={{
                  borderRadius: '50%',
                  padding: '6px',
                  color: '#263238',
                  fontSize: '20px',
                  backgroundColor: '#ffffff',
                  height: '36px',
                  width: '36px',
                  '&:hover': {
                    backgroundColor: '#455a64',
                    color: '#ffffff',
                  },
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                  transition: 'background-color 0.3s ease',
                }}
              >
                <ArrowBackIcon sx={{ fontSize: '20px' }} />
              </IconButton>
            </Tooltip>
            {canWrite("UPLOADING SALES") && (

            <button
              type="button"
              onClick={this.uploadTanGetApiHandler}
              className="button-primary"
              disabled={this.state.isLoaderforupdateTanButton}
            >
              {this.state.isLoaderforupdateTanButton ? "updating..." : "Update TAN"}
            </button>
            )}
          </Box>
          <ZohoModel
            openZohoDrawer={this.state.openZohoDrawer}
            buttonColor={this.state.buttonColor}
            establishConnection={this.establishConnection}
            messageForConnection={this.state.messageForConnection}
            timerForZohoInSalesCustomer={this.state.timerForZohoInSalesCustomer}
            closeZohoDrawer={this.closeZohoDrawer}
            zohoDateChangeHandler={this.zohoDateChangeHandler}
            effitracImportFormloader={this.state.effitracImportFormloader}
            fetchingdataForZoho={this.fetchingdataForZoho}
            zohoDate={this.state.zohoDate}
            logApitName="seller_customer"
            nameOfTheModel="Business Customer Management"
            importToCWS={this.importToCWS}
            exportToExcel={this.export_to_excel}
            zohoTableHeader={this.state.effitracHeader}
            zohoTableColumn={this.state.effitracCol}
            drawerKeys={this.state.actionHeaderForZoho}
            autoSync={this.state.autoSync}
            setAutoSync={this.handleAutoSyncChange}
          />

          <ErpConnectorModel
            opeErpConnector={this.state.erpConnectorModelOpen}
            closeErpConnector={this.closeErpDrawer}
            logApitName="customer"
            nameOfTheModel="Business Customer Management"
            importToCWS={this.importToCWS}
            exportToExcel={this.export_erp_data_to_excel}
            ErpTableHeader={this.state.effitracHeader}
            ErpTableColumn={this.state.effitracCol}
            connecotrName={this.state.erpConnectorName}
            erpDataExportLoading={this.state.erpDataExportLoading}
            importToCwsLoading={this.state.importToCwsLoading}
          />

          <BasicModal
            title={"Update Tan"}
            enableFooter={true}
            open={this.state.isOpenUpdateTanModal}
            modalBody={
              this.state.updateTanGetApiData.status === false ? (
                <p style={{ color: "red" }}>
                  {this.state.updateTanGetApiData.message}
                </p>
              ) : (
                <p>{this.state.updateTanGetApiData.message}</p>
              )
            }
            modalSize={"md"}
            onClose={this.uploadTanCancelHandler}
            modalFooter={
              <>
                {
                  this.state.updateTanGetApiData.status &&
                  <button
                    className="button-primary"
                    type="button"
                    style={{ marginRight: "10px" }}
                    onClick={this.uploadTanPostApiHandler}
                    disabled={
                      this.state.updateTanGetApiData.status === false ? true : false
                    }
                  >
                    ok
                  </button>
                }
                <button
                  className="button-outlined-secondary"
                  type="button"
                  onClick={this.uploadTanCancelHandler}
                >
                  Close
                </button>
              </>
            }
          />

          <div>
            <BoxWrapper
              boxTitle="Upload Customer History"
              zohoEffitracEnable={
                localStorage.getItem("Client_ID") &&
                !this.state.isEffitrac &&
                canWrite("UPLOADING SALES") &&
                true
              }
              enableAddButton={this.state.erpConnectorName && canWrite("UPLOADING SALES") ? true : false}
              addButtonLabel={this.state.erpConnectorName}
              addButtonHandlerFn={this.handleErpConnectorButton}
              zohoEffitracFn={this.handleZohoDrawer}
              enableImportToEffTallybutton={
                localStorage.getItem("Trigger_Effitrac/Tally_Button") &&
                localStorage.getItem("Trigger_Effitrac/Tally_Button") ===
                "true" &&
                !this.state.isEffitrac &&
                true
              }
              importToEffiTallyFn={this.import_Effitrac_tally}
            >
              <div style={{ marginBottom: "10px" }}>
                <this.CollectionListActions />
              </div>

              <div className="responsive-table">
                <table className="custome-table">
                  <thead>
                    <tr>
                      <th>Last Upload Date & Time</th>
                      <th>Status</th>
                      <th>Upload Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.uploadHistoryTableData.map((item, i) => {
                      const isDisabled =
                        item.status === "In Progress" ||
                        item.status === "Uploaded";

                      return (
                        <tr key={i}>
                          <td>{item.upload_date}</td>
                          <td>{item.status}</td>
                          <td>{item.upload_type}</td>
                          <td>
                            <RemoveRedEyeOutlinedIcon
                              className={
                                isDisabled
                                  ? "action-icon-button-disabled"
                                  : "action-icon-button showIcon"
                              }
                              color={isDisabled ? "disabled" : "inherit"}
                              onClick={
                                isDisabled
                                  ? undefined
                                  : () => this.uploadReport(item.id)
                              }
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    {this.state.uploadHistoryTableData.length === 0 && (
                      <tr>
                        <td
                          colspan={4}
                          style={{ color: "red", textAlign: "center" }}
                        >
                          No Data Found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </BoxWrapper>
          </div>

          {this.state.showUploadData ? (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <div className={classes.Main_frame}>
                    <div className={classes.form_title_bar}>
                      <div class="form_title_name">
                        <ul
                          style={{
                            listStyle: "none",
                            marginBottom: "0px",
                            padding: "0px",
                            marginTop: "0px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <li style={{ fontWeight: "700" }}>Upload Details</li>
                          <li>
                            {this.state.error_records > 0 && (
                              <button
                                className="button-outlined-primary"
                                onClick={this.errorLogExportHandlerForUpload}
                                disabled={this.state.loadingExport}
                              >
                                {this.state.loadingExport ? (
                                  <span>Loading...</span>
                                ) : (
                                  <span>Export</span>
                                )}
                              </button>
                            )}

                            <button
                              className="close-icon-button"
                              onClick={this.closeUploadData}
                            >
                              <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className={classes.form_body_part}>
                      {this.state.total_records > 0 && (
                        <div>
                          <div
                            style={{ marginLeft: "30px", marginRight: "30px" }}
                          >
                            <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor="#6f9eaf"
                                  cardTitle="Total Records"
                                  cardBody={this.state.total_records}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor="#007965"
                                  cardTitle="Successful Records"
                                  cardBody={this.state.successful_records}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor="#eb596e"
                                  cardTitle="Error Records"
                                  cardBody={this.state.error_records}
                                />
                              </Grid>
                            </Grid>
                          </div>

                          <div
                            style={{
                              height: "300",
                              margin: "20px 30px 0px 30px",
                            }}
                          >
                            <Grid container spacing={3}>
                              <Grid item xs={12}>
                                <div>
                                  <MuiThemeProvider>
                                    <DataTables
                                      columns={this.state.sellerCustomerCol}
                                      data={this.state.sellerCustomerData}
                                      selectable={false}
                                      page={this.state.errorPage}
                                      count={this.state.errortotal}
                                      rowSize={this.state.perErrorPages}
                                      showRowSizeControls={true}
                                      showFooterToolbar={true}
                                      onNextPageClick={this.handleNextPage}
                                      onPreviousPageClick={this.handlePreviousPage}
                                      onRowSizeChange={this.handleRowsPerPageChange}
                                    />

                                  </MuiThemeProvider>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      )}
                      {this.state.error && (
                        <div style={{ color: "red" }}>
                          <ErrorIcon />
                          {this.state.error}
                        </div>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          ) : (
            ""
          )}
        </>}

        {/* customer table */}
        <BoxWrapper
          boxTitle="Customers Details"
          exportToExcelEnable={true}
          exportToExcelFn={this.export_filtered_or_current}
           exportToExcelEnable1={true}
          exportButtonLabel1={this.state.appliedFilters.length > 0 && this.state.activeFilters ? "Export Filtered" : "Export All"}
          exportToExcelFn1={() => {
            if (this.state.appliedFilters.length > 0 && this.state.activeFilters) {
              this.export_filtered_or_current("isExportingAll");
            } else {
              this.exportall_to_excel(this.state.allArcCustomerData);
            }
          }}
          loadingexcel={this.state.isExporting}
          loadingexcel1={this.state.isExportingAll}
          // enableSearchInput={true}
          // searchInputPlaceholder="Search..."
          // searchInputOnchange={
          //   this.state.isEffitrac
          //     ? this.handleSearchChangeForZohoEffitrack
          //     : this.handleSearchInputChange
          // }
          backButtonForZohoEnable={this.state.isEffitrac}
          backButton={this.backHandler}
          importToCwsEnableForZoho={this.state.isEffitrac}
          importToCwsForZoho={this.importToCWS}
          headerExtra={
            FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isEffitrac
              ? this.renderFilterButton()
              : null
          }
        >
          {this.state.isEffitrac ? (
            <CustomTable
              headers={this.state.effitracHeader}
              columns={this.state.effitracCol}
              data={this.state.effitracData}
              actions={this.state.actions}
            />
          ) : (
            <>
              {/* Filter button here only until it is moved into BoxWrapper */}
              {!FILTER_BUTTON_IN_BOXWRAPPER && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "8px",
                  }}
                >
                  {this.renderFilterButton()}
                </div>
              )}

              {this.renderAppliedFilterChips()}

              {/* Table on the left, filter panel (when open) on the right —
                  the panel stretches to the table's height. */}
              <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {/*
                    overflowX: "auto" makes the wide, fixed-width grouped table
                    scroll horizontally instead of squeezing 22+ columns.
                  */}
                  <div
                    className="responsive-table"
                    style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                  >
                    <table
                      className="custome-table"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        minWidth: this.getTableMinWidth(),
                        tableLayout: "fixed",
                      }}
                    >
                      <tbody>
                        {/* Grouped header: returns [groupRow, labelRow] */}
                        {this.arc_Customer_TableHeader()}
                        {this.arc_Customer__data()}
                      </tbody>
                    </table>
                  </div>

                  <TablePagination
                    rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                    component="div"
                    count={this.state.rowCount}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </div>

                {this.renderFilterPanel()}
              </div>
            </>
          )}
        </BoxWrapper>

        <RightDrawer
          drawerName="Import Effitrac/Tally"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeEffitracDrawer}
        >
          <div style={{ textAlign: "center" }}>
            Last Upload Date<br></br>
            {this.state.lastUploadDate} {this.state.lastUploadTime}
          </div>

          <ValidatorForm
            ref="form"
            onSubmit={this.fetchEffitacFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ marginTop: "20px" }}>
              <label>
                Created From Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                fullWidth
                name="createdFromDate"
                value={this.state.importEffitracFetchData.createdFromDate ?? ""}
                onChange={(v) =>
                  this.importEffitracCreatedFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Created To Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="createdToDate"
                value={this.state.importEffitracFetchData.createdToDate ?? ""}
                onChange={(v) =>
                  this.importEffitracCreatedToDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified From Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={
                  this.state.importEffitracFetchData.modifiedFromDate ?? ""
                }
                onChange={(v) => this.importEffitracFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified To Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.importEffitracFetchData.modifiedToDate ?? ""}
                onChange={(v) =>
                  this.importEffitracModifiedToDateChangeHandler(v)
                }
              />
            </div>
            <div className="mt-20">
              {this.state.effitracImportFormloader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}

              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeEffitracDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>

        <RightDrawer
          drawerName="Customer Details"
          open={this.state.showDrawer}
          onClose={this.showToggleDrawerClose}
        >
          <>
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact Name"
              value={this.state.showData.CustContactName ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact Email"
              value={this.state.showData.CustContactEmail ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact No"
              value={this.state.showData.CustContactNo ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Address"
              value={this.state.showData.CustAddress ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="State"
              value={this.state.showData.CustState ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Country"
              value={this.state.showData.CustCountry ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Account Manager Name"
              value={this.state.showData.CustAcctmgrName ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Account Manager Email"
              value={this.state.showData.CustAcctmgrEmail ?? ""}
            />
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Account Manager Number"
              value={this.state.showData.CustAcctmgrNo ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Credit Limit"
              value={this.state.showData.CustCreditLimit ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Credit Days"
              value={this.state.showData.CustCreditDays ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Registration Type"
              value={this.state.showData.CustRegistrationType ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="TDS %"
              value={this.state.showData.tds_percentage ?? ""}
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Create Date"
              value={this.state.showData.created_date ?? ""}
            />
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Modify Date"
              value={this.state.showData.modified_date ?? ""}
            />
          </>
          <button
            className="button-outlined-secondary mt-20"
            onClick={this.showToggleDrawerClose}
          >
            Close
          </button>
        </RightDrawer>

        <Drawer
          anchor="right"
          open={this.state.add_DrawerOpen}
          onClose={this.add_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            <ValidatorForm
              ref="form"
              onSubmit={this.addCustomer_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                value={this.state.addCustomerData.customerCode ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="legal Name"
                name="legalName"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.legalName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Country"
                name="country"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.country ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="State"
                name="state"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.state ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Address"
                name="address"
                value={this.state.addCustomerData.address ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Name"
                name="contactName"
                requiredField=""
                value={this.state.addCustomerData.contactName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Number"
                name="contactNumber"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.addCustomerData.contactNumber ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Email"
                name="email"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.addCustomerData.email ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                value={this.state.addCustomerData.gstin ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                requiredField={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? "*"
                    : ""
                }
                validator={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["required", "matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]
                    : ["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]
                }
                errorMsg={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["This field is required", "Invalid PAN Number"]
                    : ["Invalid PAN Number"]
                }
                value={this.state.addCustomerData.pan ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TAN"
                name="tan"
                validator={["matchRegexp:[A-Z]{4}[0-9]{5}[A-Z]{1}"]}
                errorMsg={["Invalid TAN Number"]}
                value={this.state.addCustomerData.tan ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Name"
                name="acctmgrName"
                value={this.state.addCustomerData.acctmgrName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Contact Number"
                name="acctmgrNo"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.addCustomerData.acctmgrNo ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Email"
                name="acctmgrEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.addCustomerData.acctmgrEmail ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Credit Days"
                name="creditDays"
                validator={["matchRegexp:[0-9]"]}
                errorMsg={["Must be number"]}
                value={this.state.addCustomerData.creditDays ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Credit Limit:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCustomerData: {
                        ...prevState.addCustomerData,
                        creditLimit: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <SelectField
                SelectLabel="GSTRegistration Type"
                choice_id="id"
                choice_name="GSTRegistrationType"
                name="gstrRegistrationType"
                value={this.state.addCustomerData.gstrRegistrationType ?? ""}
                choices={[
                  { id: "Regular", GSTRegistrationType: "Regular" },
                  { id: "Unregistered", GSTRegistrationType: "Unregistered" },
                  { id: "Consumer", GSTRegistrationType: "Consumer" },
                  { id: "Composition", GSTRegistrationType: "Composition" },
                  { id: "Unknown", GSTRegistrationType: "Unknown" },
                ]}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TDS %"
                name="tdsPercentage"
                requiredField=""
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addCustomerData.tdsPercentage ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
                disabled={this.state.buttonDisabled}
              >
                {this.state.buttonDisabled ? "Uploading..." : "Submit"}
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.add_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        <Drawer
          anchor="right"
          open={this.state.edit_DrawerOpen}
          onClose={this.edit_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            <ValidatorForm
              ref="form"
              onSubmit={this.editCustomer_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCustomerData.customerCode ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="legal Name"
                name="legalName"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCustomerData.legalName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Country"
                name="country"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCustomerData.country ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="State"
                name="state"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCustomerData.state ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Address"
                name="address"
                value={this.state.editCustomerData.address ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Name"
                name="contactName"
                value={this.state.editCustomerData.contactName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Number"
                name="contactNumber"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.editCustomerData.contactNumber ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Email"
                name="email"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.editCustomerData.email ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCustomerData.gstin ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputProps={{ readOnly: true }}
                inputType="text"
                textLabel="PAN"
                name="pan"
                requiredField={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? "*"
                    : ""
                }
                validator={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["required", "matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]
                    : ["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]
                }
                errorMsg={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["This field is required", "Invalid PAN Number"]
                    : ["Invalid PAN Number"]
                }
                value={this.state.editCustomerData.pan ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TAN"
                name="tan"
                validator={["matchRegexp:[A-Z]{4}[0-9]{5}[A-Z]{1}"]}
                errorMsg={["Invalid TAN Number"]}
                value={this.state.editCustomerData.tan ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Name"
                name="acctmgrName"
                value={this.state.editCustomerData.acctmgrName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Contact Number"
                name="acctmgrNo"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.editCustomerData.acctmgrNo ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Account Manager Email"
                name="acctmgrEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.editCustomerData.acctmgrEmail ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Credit Days"
                name="creditDays"
                validator={["matchRegexp:[0-9]"]}
                errorMsg={["Must be number"]}
                value={this.state.editCustomerData.creditDays ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Credit Limit:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  value={
                    this.state.editCustomerData.creditLimit
                      ? this.state.editCustomerData.creditLimit
                      : ""
                  }
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editCustomerData: {
                        ...prevState.editCustomerData,
                        creditLimit: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>
              <SelectField
                SelectLabel="GST Registration Type"
                choice_id="id"
                choice_name="GSTRegistrationType"
                name="gstrRegistrationType"
                value={this.state.editCustomerData.gstrRegistrationType ?? ""}
                choices={[
                  { id: "Regular", GSTRegistrationType: "Regular" },
                  { id: "Unregistered", GSTRegistrationType: "Unregistered" },
                  { id: "Consumer", GSTRegistrationType: "Consumer" },
                  { id: "Composition", GSTRegistrationType: "Composition" },
                  { id: "Unknown", GSTRegistrationType: "Unknown" },
                ]}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TDS %"
                name="tdsPercentage"
                requiredField=""
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editCustomerData.tdsPercentage ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
                disabled={this.state.buttonDisabled}
              >
                {this.state.buttonDisabled ? "Uploading..." : "Submit"}
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.edit_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        <RightDrawer
          drawerName="Effitrac/Tally Details"
          open={this.state.effitracInvShow}
          onClose={this.closeEffitracInvShowHandler}
        >
          <>
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact Name"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_contact_name
              }
            />
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact Email"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_contact_email
              }
            />
            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Contact No"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_contact_no
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Address"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_address
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="State"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_state
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Country"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_country
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Account Manager Name"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_acctmgr_name
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Account Manager Email"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_acctmgr_email
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Credit Limit"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_credit_limit
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Credit Days"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].cust_credit_days
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="Registration Type"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId]
                  .cust_registration_type
              }
            />

            <TextField
              className={classes.showTextField}
              inputProps={{ readOnly: true }}
              fullWidth
              label="TDS %"
              value={
                this.state.targetId != null &&
                this.state.effitracData[this.state.targetId].tds_percentage
              }
            />
          </>
          <button
            className="button-outlined-secondary mt-20"
            onClick={this.closeEffitracInvShowHandler}
          >
            Back
          </button>
        </RightDrawer>
      </React.Fragment>
    );
  }
}

export default withRouter(BussinessCustomerMang);